import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { BOSSCI_CASE_SEARCH_QUERY } from '../../../graphql.js'
import CaseSearchForm from './CaseSearchForm.js'
import { getData } from '../CustomUtils.js'
import ColumnHeadings from '../ColumnHeadings.js'

const BOSSCI_CASE_SEARCH = gql(BOSSCI_CASE_SEARCH_QUERY)

export default function CaseSearch({ location, largeChoiceCallback, caseSearchCallback }) {
  console.log('CaseSearch rendered:', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, BOSSCI_CASE_SEARCH, 'bossciCaseSearch', setResults, setGraphQLErrors)
  }, [location])

  function selectClicked(e) {
    console.log('selectClicked',e.target)
    const selectedValue = {
      value: e.target.id,
      label: e.target.value
    }
    largeChoiceCallback(selectedValue)
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const resultRows = []
    let row = []
    for (let i = 0; i < results.reportData.length; i++) {
      for (let j = 0; j < results.reportData[i].length - 1; j++) {
        row.push(<td key={j}>{results.reportData[i][j]}</td>)
      }
      // select button
      row.push(<td key={-i-1}><Button id={results.reportData[i][0] /* recordId */} 
        value={`Record ID: ${results.reportData[i][0]} - ${results.reportData[i][3]} ${results.reportData[i][2]}` /* firstName lastName*/} 
        onClick={(e) => selectClicked(e)}>Select</Button></td>)
      resultRows.push(<tr key={i}>{row}</tr>)
      row = []
    }
    return (
      <div className="custom-scroll">
        <CaseSearchForm location={location} caseSearchCallback={caseSearchCallback}/>
        <Table bordered style={{width: 'auto', marginLeft: 'auto', marginRight: 'auto'}}>
          <thead>
            <ColumnHeadings results={results} noNumberRow={true} />
          </thead>
          <tbody>
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}
